import merge from "deepmerge";

const base = {
      appFullName: "Node Extension Special Instructions",
      appName: "NodeExtSpclInstrcn",
      description: "Node Extension Special Instructions",
      isProd: false,
      // Shared max FFR count for bulk actions (Retry & Cancel) in the FFR Retry/Cancel UI.
      maxBulkFfrCount: 10,
      oAuth: {
        clientId: "nike.gfls.node-ext-spcl-intrcn",
        redirectUri: window.location.origin,
        userInfo:
            "https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/userinfo",
        scopes: [
          "fulfillment:node.ext.spcl.intrcn::create: fulfillment:node.ext.spcl.intrcn::read: fulfillment:node.ext.spcl.intrcn::update: fulfillment:node.ext.spcl.intrcn::delete: fulfillment:node.ext.spcl.intrcn::execute: fulfillment:node.fr.preprocessor::read: fulfillment:node.fr.preprocessor::create: fulfillment:node.fr.preprocessor::delete: node_management:node.ext.location.mgmt::create: node_management:node.ext.location.mgmt::read: node_management:node.ext.location.mgmt::delete: node_management:node.ext.loading.group::update: node_management:node.ext.loading.group::read: profile openid email",
        ],
      },
    },
    dev = merge(base, {
      //"http://localhost:9000",
      customerApi:
          "https://node-fr-data-mgmt-ap-dev.nodemanagement-test.nikecloud.com",
        loadingGroupApi:
            "https://node-ext-loading-group-svc-dev-ap.nike.com",
        ffrRetryApi:
            "https://node-fr-data-mgmt-ap-dev.nodemanagement-test.nikecloud.com",
      splunkEnv: "dev",
      splunkGeo: "ap",
    }),
    prod = merge(base, {
      customerApi:
          "https://node-fr-data-mgmt-ap-prod.nodemanagement-prod.nikecloud.com",
      loadingGroupApi:
          "https://node-ext-loading-group-svc-prod-ap.nike.com",
        ffrRetryApi:
            "https://node-fr-data-mgmt-ap-prod.nodemanagement-prod.nikecloud.com",
      isProd: true,
      splunkEnv: "prod",
      splunkGeo: "ap",
    }),
    test = merge(base, {
      customerApi:
          "https://node-fr-data-mgmt-ap-test.nodemanagement-test.nikecloud.com",
      loadingGroupApi:
          "https://node-ext-loading-group-svc-test-ap.nike.com",
        ffrRetryApi:
            "https://node-fr-data-mgmt-ap-test.nodemanagement-test.nikecloud.com",
      splunkEnv: "test",
      splunkGeo: "ap",
    }),
    vpt = merge(base, {
      customerApi:
          "https://node-fr-data-mgmt-ap-vpt.nodemanagement-test.nikecloud.com",
      loadingGroupApi:
          "https://node-ext-loading-group-svc-vpt-ap.nodemanagement-test.nikecloud.com",
        ffrRetryApi:
            "https://node-fr-data-mgmt-ap-vpt.nodemanagement-test.nikecloud.com",
      splunkEnv: "test",
      splunkGeo: "ap",
    }),
    stage = merge(base, {
      customerApi:
          "https://node-fr-data-mgmt-ap-stg.nodemanagement-test.nikecloud.com",
      loadingGroupApi:
          "https://node-ext-loading-group-svc-stage-ap.nodemanagement-test.nikecloud.com",
        ffrRetryApi:
            "https://node-fr-data-mgmt-ap-stg.nodemanagement-test.nikecloud.com",
      splunkEnv: "test",
      splunkGeo: "ap",
    });

let env = dev;
if (
    window.location.origin.includes("nodeconfig-ui-ap.nike.com") ||
    window.location.origin.includes("nodeconfig-ui-ap-prod.nodemanagement-prod.nikecloud.com")
    //window.location.origin.includes("node-extn-spcl-instrcn-prod.nike.com")
) {
  env = prod;
} else if (
  window.location.origin.includes("nodeconfig-ui-dev.nike.com") ||
  window.location.origin.includes("node-extn-spcl-instrcn-dev.nike.com") ||
  window.location.origin.includes("nodeconfig-ui-ap-dev.nike.com")
) {
  env = dev;
} else if (
  window.location.origin.includes("nodeconfig-ui-ap-test.nike.com") ||
  window.location.origin.includes("nodeconfig-ui-ap-test.nodemanagement-test.nikecloud.com")
) {
  env = test;
} else if (
    window.location.origin.includes("nodeconfig-ui-ap-stage.nike.com") ||
    window.location.origin.includes("nodeconfig-ui-ap-stage.nodemanagement-test.nikecloud.com") ||
    window.location.origin.includes("node-extn-spcl-instrcn-stage.nike.com")
) {
  env = stage;
} else if (
    window.location.origin.includes("nodeconfig-ui-vpt.nike.com") ||
    window.location.origin.includes("node-extn-spcl-instrcn-vpt.nike.com")
) {
  env = vpt;
}
const config = env;
export default config;
